import Header from '../../components/Header';
import StatusDropdown from '../../components/StatusDropdown';
import ManagerSidebar from '../../components/manager/ManagerSidebar';
import InvoicingTab from '../../components/manager/InvoicingTab';
import InvoicingStatusCard from '../../components/manager/invoicingStatusCard';

// laundry status data
const laundryStatus = [
  { label: 'All', link: '#' },
  { label: 'Binned', link: '#' },
  { label: 'Washing', link: '#' },
  { label: 'Drying', link: '#' },
  { label: 'Folding', link: '#' },
];

const InvoicingScreen = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <ManagerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Invoices'} orderSubtitle={'Manage order invoices'} showButton={false} /> 
          <section className='mt-10 flex gap-5'>
            <InvoicingStatusCard invoicePaymentStatus={'Overdue'} noOfOrdersClassName={'custom-style'} invoiceRevenue={'$0.00'} noOfOrders={0} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-52" />}/>
            <InvoicingStatusCard invoicePaymentStatus={'Unpaid'} noOfOrdersClassName={'custom-style'} invoiceRevenue={'$130.72'} noOfOrders={1} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-56" />}/>
            <InvoicingStatusCard invoicePaymentStatus={'Paid'} noOfOrdersClassName={'custom-style'} invoiceRevenue={'$2,830.72'} noOfOrders={26} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-64" />}/>
          </section>
          <section className='mt-20 flex gap-4'>
            <section>
              <InvoicingTab />
            </section>
          </section>
        </main>
      </section>

    </>
  )
}
export default InvoicingScreen